const ScrollerType = {
	simpleBar: 'simpleBar',
	carousel: 'carousel',
};

export default ScrollerType;